<svelte:options tag="scroll-to-top" />

<svelte:window on:scroll={handleOnScroll} />

<div id="back-to-top" on:click={goTop} class:hidden>
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="chevron-circle-up"
    class="svg-inline--fa fa-chevron-circle-up fa-w-16"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    ><path
      fill="currentColor"
      d="M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
    /></svg
  >
</div>

<script>
  let hidden = true

  const goTop = () => {
    document.body.scrollIntoView()
    hidden = true
  }

  const scrollContainer = () => {
    return document.documentElement || document.body
  }

  const handleOnScroll = () => {
    if (!scrollContainer()) {
      return
    }
    hidden = scrollContainer().scrollTop <= 80
  }
</script>

<style type="text/scss">
  #back-to-top {
    opacity: 1;
    width: 40px;
    height: 40px;
    padding: 10px 20px;
    position: fixed;
    bottom: 75px;
    right: 20px;
    color: #444;
    cursor: pointer;
    visibility: visible;
    transition: visibility 0s linear 0s, opacity 300ms;

    @media print {
      display: none;
    }
  }

  #back-to-top.hidden {
    opacity: 0;
    visibility: hidden;
    transition: visibility 0s linear 300ms, opacity 300ms;
  }
</style>
